import Config from 'netxcore@netx/core-cart/config';

Object.assign(Config, {
	SHARE_SYNC_IMMEDIATE: true,
	//SHARE_SHOW_OWNER: false
});

export default Config;
